module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("dMv2G"))).then(() => parcelRequire('f4eak'));